module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-detail"
  }, [_c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("单位全称")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.name))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#999",
      "margin-left": "160px",
      "margin-bottom": "22px"
    }
  }, [_vm._v("注：企业类型不支持修改，如类型选择错误，请在设置中注销后，重新注册")]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("单位地址")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.cityName))]), _vm._v(" "), _c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.countyName))]), _vm._v(" "), _c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.address))])])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("联系人")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.linkMan))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.phone))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("中心坐标")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v("东经：" + _vm._s(_vm._f("formatDegree")(_vm.orgdetail.longitude)) + "，北纬：" + _vm._s(_vm._f("formatDegree")(_vm.orgdetail.latitude)))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("所属区划")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, _vm._l((_vm.orgdetail.regions), function(m) {
    return _c('p', {
      key: m.id
    }, [_c('span', {
      staticClass: "form-registry"
    }, [_vm._v(_vm._s(_vm.orgdetail.regions[0].province.name))]), _vm._v(" "), _c('span', {
      staticClass: "form-registry"
    }, [_vm._v(_vm._s(_vm.orgdetail.regions[0].city.name))]), _vm._v(" "), _c('span', {
      staticClass: "form-registry"
    }, [_vm._v(_vm._s(_vm.orgdetail.regions[0].county[0].name))])])
  }))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "158px",
      "position": "relative"
    },
    attrs: {
      "type": "info"
    }
  }, [_vm._v("\n    查看一企一码\n    "), _c('viewer', {
    staticClass: "qrcodeImg",
    attrs: {
      "images": _vm.qrcodeList
    }
  }, _vm._l((_vm.qrcodeList), function(src, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": src
      }
    })
  }))], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "form-item",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("企业类型")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v("\n      政府单位\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0502c799","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plan/Govdetail.vue
// module id = 1168
// module chunks = 2